module.exports = __webpack_public_path__ + "29bad8e0b0e6cf92f1f7d22f7fcfba79.ttf";